import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from 'react';

import { PageInformationContext } from '@/context/PageInformationContext';
import { useAppSelector } from '@/hooks/redux-hooks';

interface MarketContextType {
  activeTab: number;
  setActiveTab: Dispatch<SetStateAction<number>>;
}

const MarketContext = createContext<MarketContextType | undefined>(undefined);

interface NavigationProviderProps {
  children: ReactNode;
}

export const MarketProvider = ({ children }: NavigationProviderProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const markets = useAppSelector(state => state.markets.markets);

  const value = useMemo(
    () => ({
      activeTab,
      setActiveTab
    }),
    [activeTab]
  );
  const pageInformation = useMemo(() => {
    return {
      mainPageTitle: markets?.metadata?.displayName ?? '',
      subPageTitle: markets?.pages[activeTab]?.name ?? ''
    };
  }, [markets, activeTab]);

  return (
    <MarketContext.Provider value={value}>
      <PageInformationContext.Provider value={pageInformation}>
        {children}
      </PageInformationContext.Provider>
    </MarketContext.Provider>
  );
};

export const useMarketContext = () => {
  const context = useContext(MarketContext);
  if (!context) throw new Error('useMarketContext must be used within MarketProvider');
  return context;
};
